import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FaThumbsUp, FaThumbsDown, FaTerminal, FaBars, FaTimes, FaLock, FaUserCircle, FaGlobe, FaRocket, FaBookDead } from "react-icons/fa";
import "../kaipedia/kaipedia.css";
import MusicPlayer from "../../../components/MusicPlayer";

const demoBlogs = [
    { id: 17, category: "Tech", title: "Playing Data with Python", image: "/kuma.jpg", upVotes: 0, downVotes: 0, author: "System_K31", authorImg: "About_SystemK13.png" },

    { id: 13, isLocked: true, category: "Random", title: "Kawasaki W-", image: "/K_1.png", upVotes: 3, downVotes: 1, author: "System_K31", authorImg: "About_SystemK13.png" },
];


const sidebarItems = [
    { 
        title: "Penetration Testing", 
        category: "CYBERSECURITY", 
        subtitle: "Kali Linux Advanced Tools", 
        image: "/K_1.png", 
        Url: "https://www.kali.org/",
    },
    { 
        title: "Security OS", 
        category: "CYBERSECURITY", 
        subtitle: "Parrot Security OS", 
        image: "/K_1.png", 
        Url: "https://parrotsec.org/",
    },
    { 
        title: "Nature Journal", 
        category: "SCIENCE & RESEARCH", 
        subtitle: "Journal of Science", 
        image: "/K_1.png", 
        Url: "https://www.nature.com/",
    },
];

const KlogPage: React.FC = () => {
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [activeTag, setActiveTag] = useState("ALL");
    const tags = ["ALL", "TECH", "OPINION", "RANDOM"];
    const [showToast, setShowToast] = useState(false);

    const triggerLockToast = () => {
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
    };

    const filteredBlogs = useMemo(() => {
        let result = [...demoBlogs];
        if (activeTag === "ALL") return result.sort((a, b) => b.id - a.id);
        if (activeTag === "RANDOM") {
            return result.filter(blog => 
                blog.category.toUpperCase() !== "TECH" && 
                blog.category.toUpperCase() !== "OPINION"
            );
        }
        return result.filter(blog => blog.category.toUpperCase() === activeTag);
    }, [activeTag]);

    const RightContent = () => (
        <div className="space-y-8 mt-10">
            <section>
                <h4 className="text-[10px] font-black text-blue-400 uppercase tracking-[0.3em] mb-5 flex items-center gap-3">
                    <span className="w-4 h-[1px] bg-cyan-500"></span> Recommendation
                </h4>
                <div className="space-y-3">
                    {sidebarItems.map((item, idx) => (
                        <a href={item.Url} target="" key={idx} className="group cursor-pointer flex gap-3 p-2 rounded-xl hover:bg-white/5 transition-all">
                            <div className="w-10 h-10 shrink-0 border border-cyan-500/20 rounded-lg overflow-hidden">
                                <img src={item.image} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all" alt="" />
                            </div>
                            <div className="min-w-0">
                                <p className="text-[7px] text-cyan-500 font-bold uppercase">{item.category}</p>
                                <a className="text-[10px] font-black text-white group-hover:text-cyan-400 truncate uppercase">{item.title}</a>
                                <p className="text-[8px] text-slate-500 italic font-mono uppercase tracking-tighter">{item.subtitle}</p>
                            </div>
                        </a>
                    ))}
                </div>
            </section>
        </div>
    );

    return (
        <>
            <div className="starry-bg min-h-screen bg-[#050b18] text-slate-200 font-sans flex justify-center overflow-hidden selection:bg-cyan-500/30">
                
                <div className={`fixed inset-0 z-[100] lg:hidden transition-all duration-300 ${isMenuOpen ? "visible" : "invisible"}`}>
                    <div className={`absolute inset-0 bg-slate-950/90 backdrop-blur-md transition-opacity ${isMenuOpen ? "opacity-100" : "opacity-0"}`} onClick={() => setIsMenuOpen(false)} />
                    <aside 
                        className={`absolute inset-y-0 left-0 w-72 bg-[#0a1628] border-r border-cyan-500/30 p-6 
                        transform transition-transform duration-300 flex flex-col
                        ${isMenuOpen ? "translate-x-0" : "-translate-x-full"}`}
                    >
                        <div className="flex justify-between items-center mb-0 shrink-0">
                            <h2 className="text-sm font-black text-cyan-400 tracking-widest uppercase italic">
                                System_Menu
                            </h2>
                            <FaTimes 
                                className="text-cyan-400 cursor-pointer hover:rotate-90 transition-transform" 
                                onClick={() => setIsMenuOpen(false)} 
                            />
                        </div>

                        <div className="flex-1 overflow-y-auto pr-2 custom-scrollbar">
                            <div className="mt-1 pb-10">
                                <div className="mt-1">
                                    <MusicPlayer mobile />
                                </div>
                            </div>
                        </div>
                    </aside>
                </div>

                <main className="flex-1 max-w-2xl xl:max-w-3xl flex flex-col h-screen overflow-y-auto border-x border-cyan-500/10 bg-slate-900/[0.05] backdrop-blur-3xl custom-scrollbar z-10 lg:mx-[18rem]">
                    <header className="sticky top-0 z-50 bg-[#0a1628]/95 backdrop-blur-xl border-b-2 border-cyan-400/50 shadow-[0_10px_30px_-10px_rgba(6,182,212,0.4)] px-8 py-6">
                        
                        <div className="flex justify-between items-center mb-6">
                            <div>
                                <h2 className="text-xl font-black text-white tracking-widest uppercase italic leading-none">
                                    KAI<span className="text-cyan-500">PEDIA</span>
                                </h2>
                                <p className="text-[8px] font-mono text-slate-500 uppercase mt-1">Sector_13 // Public_Access</p>
                            </div>
                            <button onClick={() => setIsMenuOpen(true)} className="lg:hidden p-2 text-cyan-400 bg-cyan-500/10 border border-cyan-500/30 rounded-lg active:scale-95 transition-transform">
                                <FaBars size={20} />
                            </button>
                        </div>

                        <div className="flex gap-2 overflow-x-auto no-scrollbar">
                            {tags.map(tag => (
                                <button 
                                    key={tag} 
                                    onClick={() => setActiveTag(tag)} 
                                    className={`px-6 py-2 text-[10px] uppercase font-black tracking-widest rounded-xl border-2 transition-all duration-300 whitespace-nowrap ${
                                        activeTag === tag 
                                        ? 'bg-cyan-500 border-cyan-300 text-[#050b18] shadow-[0_0_15px_rgba(6,182,212,0.4)]' 
                                        : 'border-cyan-500/10 text-slate-500 hover:text-cyan-300 hover:border-cyan-500/30'
                                    }`}
                                >
                                    {tag}
                                </button>
                            ))}
                        </div>
                    </header>

                    <div className="flex flex-col p-4 sm:p-8 space-y-4 pb-32 pt-10">
                        {filteredBlogs.length > 0 ? (
                            filteredBlogs.map((blog) => (
                                <article 
                                    key={blog.id} 
                                    className="group relative bg-[#0a1628]/40 border border-cyan-500/10 rounded-2xl p-4 hover:bg-[#0d1d35] hover:border-cyan-400/40 transition-all duration-300 flex flex-row items-center gap-4 sm:gap-5"
                                >
                                    <div className="w-20 h-20 sm:w-28 sm:h-24 shrink-0 rounded-xl border border-cyan-500/20 overflow-hidden bg-slate-950">
                                        <img 
                                            src={blog.image} 
                                            className="w-full h-full object-cover opacity-60 group-hover:opacity-100 transition-opacity duration-500" 
                                            alt={blog.title} 
                                        />
                                    </div>

                                    <div className="flex-1 min-w-0">
                                        <div className="flex items-center gap-2 sm:gap-3 mb-1">
                                            <span className="text-[7px] sm:text-[9px] font-bold text-cyan-500 uppercase tracking-wider bg-cyan-500/10 px-1.5 py-0.5 rounded">
                                                {blog.category}
                                            </span>
                                        </div>
                                        
                                        <h2 className="text-xs sm:text-lg font-black text-white group-hover:text-cyan-400 transition-colors leading-tight uppercase truncate">
                                            {blog.title}
                                        </h2>

                                        <div className="flex items-center gap-3 mt-2 sm:mt-3">
                                            <button className="flex items-center gap-1 text-slate-500 hover:text-cyan-400 transition-colors group/like">
                                                <FaThumbsUp size={10} className="sm:size-[12px] group-hover/like:scale-110 transition-transform" />
                                                <span className="text-[8px] sm:text-[10px] font-bold font-mono">{blog.upVotes}</span>
                                            </button>
                                            <button className="flex items-center gap-1 text-slate-500 hover:text-red-500 transition-colors group/dislike">
                                                <FaThumbsDown size={10} className="sm:size-[12px] group-hover/dislike:scale-110 transition-transform" />
                                                <span className="text-[8px] sm:text-[10px] font-bold font-mono">{blog.downVotes}</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="shrink-0 ml-2">
                                        <button 
                                            onClick={() => {
                                                if (blog.isLocked) {
                                                    triggerLockToast();
                                                } else {
                                                    navigate(`/kaipedia/${blog.id}`);
                                                }
                                            }} 
                                            className={`flex items-center justify-center gap-2 px-3 sm:px-6 py-2 sm:py-3 text-[8px] sm:text-[10px] font-black uppercase tracking-widest rounded-lg sm:rounded-xl transition-all active:scale-95 border ${
                                                blog.isLocked 
                                                ? "bg-red-500/10 border-red-500/40 text-red-500 hover:bg-red-500 hover:text-white" 
                                                : "bg-cyan-600/10 border-cyan-500/30 text-cyan-400 hover:bg-cyan-600 hover:text-white shadow-[0_0_10px_rgba(8,145,178,0.2)]"
                                            }`}
                                        >
                                            {blog.isLocked ? (
                                                <FaLock size={10} />
                                            ) : (
                                                <>
                                                    <span className="hidden xs:inline">Open</span>
                                                    <FaRocket className="animate-bounce-side" size={10} />
                                                </>
                                            )}
                                        </button>
                                    </div>

                                    <div className="absolute left-0 top-1/2 -translate-y-1/2 w-[2px] h-0 group-hover:h-2/3 bg-cyan-500 transition-all duration-300 shadow-[0_0_8px_#22d3ee]"></div>
                                </article>
                            ))
                        ) : (
                            <div className="py-24 flex flex-col items-center justify-center border border-dashed border-cyan-500/20 rounded-[2rem] bg-cyan-500/5">
                                <FaTerminal className="text-4xl text-cyan-900 mb-4 animate-pulse" />
                                <h3 className="text-cyan-500 font-black text-xs uppercase tracking-[0.4em]">Sector_Empty</h3>
                                <p className="text-[10px] text-slate-500 font-mono mt-2 uppercase tracking-tighter">No logs found</p>
                            </div>
                        )}
                    </div>
                </main>

                <aside className="hidden lg:flex fixed right-0 inset-y-0 w-80 border-l border-cyan-500/10 p-8 flex-col gap-10 bg-[#050b18] z-20 overflow-y-auto no-scrollbar">
                    <RightContent />
                    <div className="bg-gradient-to-br from-[#0a1628] to-blue-950/40 border border-cyan-500/20 p-6 rounded-[2rem] mt-auto">
                        <h4 className="text-[10px] font-black text-cyan-400 uppercase mb-3 flex items-center gap-2">
                            <FaTerminal size={12} /> Terminal_Output
                        </h4>
                        <p className="text-[10px] font-mono text-slate-500 italic">"Filter: {activeTag}"</p>
                        <div className="mt-4 flex justify-between items-center text-[9px] font-bold text-cyan-900 uppercase">
                            <span>© 2026 KAI_PEDIA</span>
                            <FaGlobe className="animate-spin-slow" />
                        </div>
                    </div>
                </aside>

            </div>
            
            <div className={`fixed top-10 left-1/2 -translate-x-1/2 z-[200] transition-all duration-500 transform ${showToast ? "translate-y-0 opacity-100" : "-translate-y-20 opacity-0 pointer-events-none"}`}>
                <div className="bg-[#0a1628]/95 backdrop-blur-md border-2 border-red-500 shadow-[0_0_25px_rgba(239,68,68,0.3)] rounded-2xl px-6 py-4 flex items-center gap-4 min-w-[320px] overflow-hidden">             
                    <div className="w-10 h-10 bg-red-500/20 rounded-full flex items-center justify-center border border-red-500/50 shrink-0">
                        <FaLock className="text-red-500 animate-pulse" size={16} />
                    </div>
            
                    <div className="flex-1">
                        <h5 className="text-red-500 text-[11px] font-black uppercase tracking-[0.2em] flex items-center gap-2">
                            <span className="w-2 h-2 bg-red-500 rounded-full animate-ping"></span>
                            Access_Denied
                        </h5>
                        <p className="text-slate-400 text-[9px] font-mono leading-tight mt-1 uppercase">
                            ERROR_403: AUTH_REQUIRED<br/>
                            <span className="text-red-400/60 tracking-tighter italic">"Log_File_Is_Encrypted"</span>
                        </p>
                    </div>
            
                    <button onClick={() => setShowToast(false)} className="text-slate-600 hover:text-white transition-colors">
                        <FaTimes size={12} />
                    </button>

                    <div className="absolute bottom-0 left-0 h-[3px] bg-red-600 transition-all duration-[3000ms] ease-linear" 
                        style={{ width: showToast ? '0%' : '100%', transitionDuration: showToast ? '3000ms' : '0ms' }}>
                    </div>
                </div>
            </div>
        </>
    );
    
};

export default KlogPage;